<template>
  <div data-test="toast-component">
    {{ message
    }}<VButton v-if="destination" @click="goToDestination" class="white">{{
      actionText
    }}</VButton>
  </div>
</template>

<script>
import VButton from "@/components/raft/VButton.vue";
import { useNotificationActions } from "@/composables/useNotificationActions";

export default {
  name: "VToastComponent",
  components: { VButton },
  props: {
    toastId: [String, Number],
    message: [String, Object],
    destination: [String, Object],
    metadata: { type: Object, default: () => {} },
  },
  setup() {
    const { downloadOrVisit } = useNotificationActions();
    return { downloadOrVisit };
  },
  computed: {
    actionText() {
      if (this.destination.hasOwnProperty("path")) {
        return "Download";
      }
      return "Go";
    },
  },
  methods: {
    goToDestination() {
      this.$emit("destination", this.destination);
      this.downloadOrVisit(this.destination, this.metadata?.job);
    },
  },
};
</script>

<style scoped>
div {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
